export default "__VITE_PUBLIC_ASSET__d778bd46__"